module.exports = __webpack_public_path__ + "img/es.30e2939e.png";